import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CpVirtualCardService {
  appConfig: EnvironmentModel = new EnvironmentModel();

  constructor(@Inject(APP_CONFIG) protected appConfigTemp: EnvironmentModel, private http: HttpClient) {
    this.appConfig = appConfigTemp;
  }

  requestVirtualCard(data: any): Observable<any> {
    const contract = atob(sessionStorage.getItem('contract')!);
    return this.http.post<any>(this.appConfig.api + 'contracts/' + encodeURIComponent(contract) + '/virtual-card', data);
  }

  // public virtualCard(contractId: string, beneficiaryData: any): Observable<any> {
  //   const data = {
  //
  //     CardNumber: beneficiaryData.beneficiary,
  //     Email: beneficiaryData.email.trim(),
  //     Phone: beneficiaryData.phone ? beneficiaryData.phone : null
  //   };
  //   return this.http.post<any>(`${environment.api}/contracts/${encodeURIComponent(contractId)}/virtual-card`, data)
  //     .pipe(map(response => response.body));
  // }
}
